module.exports = __webpack_public_path__ + "static/media/shapes-ellipse-empty.8ee81732.svg";